import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import StringUtils from '../../utils/StringUtils';

import BooksSubmitButton from '../../../components/books/common/buttons/BooksSubmitButton';
import BooksLabeledContainer from '../../../components/books/model1/BooksLabeledContainer';
import BooksFormErrorMessage from '../../../components/books/model1/forms/BooksFormErrorMessage';
import BooksTextInput, {
  TextInputType,
} from '../../../components/books/model1/forms/BooksTextInput';
import implPasswordProtectionRepository from '../../../infrastructure/repositories/PasswordProtectionRepository';

import secretImage from '../../../../public/static/books/secret.png';

import css from './MerchantCourseDetailsPageProtected.module.scss';

interface Props {
  className?: string;
  session?: string;
  servicePublicId: number;
  onSubmit: (result: boolean) => void;
}

interface State {
  password: string;
  posted: boolean;
  posting: boolean;
  result: boolean;
}

class MerchantCourseDetailsPageProtected extends React.Component<
  Props & InjectedIntlProps,
  State
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.state = { password: '', posted: false, posting: false, result: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ password: e.currentTarget.value });
  }

  private async handleSubmit() {
    const { session, servicePublicId, onSubmit } = this.props;

    const { password } = this.state;
    this.setState({ ...this.state, posting: true });

    const res = await implPasswordProtectionRepository(session).Authentication(
      'bookingService',
      servicePublicId,
      password,
    );

    this.setState({
      ...this.state,
      posted: true,
      posting: false,
      result: res.isAuthenticate,
    });
    onSubmit(res.isAuthenticate);
  }

  public render() {
    const { className, intl } = this.props;
    const { password, posted, posting, result } = this.state;
    const classes = classNames(
      css.MerchantCourseDetailsPageProtected,
      className,
    );

    return (
      <div className={classes}>
        <img
          className={css.MerchantCourseDetailsPageProtected__Img}
          src={secretImage}
          alt=""
        />
        <dl className={css.MerchantCourseDetailsPageProtected__Notes}>
          <dt className={css.MerchantCourseDetailsPageProtected__Heading}>
            {intl.formatMessage({ id: 'merchants.secret.notes.heading' })}
          </dt>
          <dd className={css.MerchantCourseDetailsPageProtected__Description}>
            {StringUtils.nl2br(
              intl.formatMessage({
                id: 'merchants.secret.notes.description',
              }),
            )}
          </dd>
        </dl>
        <div className={css.MerchantCourseDetailsPageProtected__Password}>
          <BooksLabeledContainer
            label={intl.formatMessage({ id: 'merchants.secret.password' })}
            errorStyle={posted && !result}
          >
            <BooksTextInput
              type={TextInputType.Password}
              value={password}
              onChange={this.handleChange}
            />
          </BooksLabeledContainer>
          {posted && !result && (
            <BooksFormErrorMessage>
              {intl.formatMessage({ id: 'merchants.secret.errorMessages' })}
            </BooksFormErrorMessage>
          )}
        </div>
        <BooksSubmitButton
          type="button"
          disabled={!password || posting}
          postable={!posting}
          onClick={this.handleSubmit}
          small={true}
          value={intl.formatMessage({
            id: 'books.submitLabel.ok',
          })}
        >
          {intl.formatMessage({
            id: 'books.submitLabel.ok',
          })}
        </BooksSubmitButton>
      </div>
    );
  }
}
export default injectIntl(MerchantCourseDetailsPageProtected);
